export async function fetchConfig() {
  const response = await fetch("https://menumind.smcare.net/constants.json");
  const config = await response.json();
  console.log(config);
}

export const baseUrl = "https://electro.smcare.net/menumind/api";
